'use strict';

var hasOwnProperty = {}.hasOwnProperty;
var call = Function.prototype.call;

module.exports = call.bind ? call.bind(hasOwnProperty) : function (O, P) {
  return call.call(hasOwnProperty, O, P);
};



//////////////////
// WEBPACK FOOTER
// ./~/has/src/index.js
// module id = 632
// module chunks = 0